// ! TODO: Remove unnecessary legacy insights logic from this reducer
import {
  UPDATE_GROUP_BY_OPTION,
  TOGGLE_SHOW_SNOOZED,
  UPDATE_SORT_BY_OPTION,
} from "./actionTypes";

import { GROUP_BY_OPTIONS, SORT_BY_OPTIONS } from "./utils";

const INITIAL_STATE = {
  loading: false,
  ready: false,
  groupByOption: GROUP_BY_OPTIONS.SITE.key,
  sortByOption: SORT_BY_OPTIONS.A_Z.key,
  composed: undefined,
  siteGroups: undefined,
  error: undefined,
  showSnoozed: true,
};

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case TOGGLE_SHOW_SNOOZED:
      return {
        ...state,
        showSnoozed: !state.showSnoozed,
      };
    case UPDATE_GROUP_BY_OPTION:
      return {
        ...state,
        groupByOption: action.groupByOption,
      };
    case UPDATE_SORT_BY_OPTION:
      return {
        ...state,
        sortByOption: action.sortByOption,
      };
    default:
      return state;
  }
}
